import React, {useState} from "react"
import {Box, Button, Popover, Stack} from "@mui/material"
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import PropTypes from "prop-types"
import Content from "../../../../anwendungskonfigurator/components/Content"

// Aus uwpplus-frontend migriert. Anpassung an VW: `containers` -> `children`,
// Kinder via VW-Content (`child=`), Datenzugriff/props über VW-Container-Contract.
const ContainerDropdown = ({container, disabled}) => {
    const {label, children = [], panelWidth} = container
    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)

    const handleOpen = (event) => setAnchorEl(event.currentTarget)
    const handleClose = () => setAnchorEl(null)

    return (
        <Box>
            <Button
                variant="outlined"
                onClick={handleOpen}
                endIcon={
                    <KeyboardArrowDownIcon
                        sx={{
                            transition: "transform 0.2s",
                            transform: open ? "rotate(180deg)" : "none",
                        }}
                    />
                }
                sx={{
                    justifyContent: "space-between",
                    textTransform: "none",
                    minWidth: 220,
                }}
            >
                {label}
            </Button>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{vertical: "bottom", horizontal: "left"}}
                transformOrigin={{vertical: "top", horizontal: "left"}}
                slotProps={{
                    paper: {
                        sx: {
                            width: panelWidth ? Number(panelWidth) : 320,
                            p: 2,
                            mt: 1,
                        },
                    },
                }}
            >
                <Stack spacing={2}>
                    {children.map((child) => (
                        <Content key={child.id} child={child} disabled={disabled} />
                    ))}
                </Stack>
            </Popover>
        </Box>
    )
}

ContainerDropdown.propTypes = {
    container: PropTypes.object,
    disabled: PropTypes.bool,
}

export default ContainerDropdown
